import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=6a701a94&scoped=true&"
import script from "./TeachersTable.vue?vue&type=script&lang=js&"
export * from "./TeachersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a701a94",
  null
  
)

export default component.exports